module.exports = __webpack_public_path__ + "static/media/pano_drag_360.b2b26f8a.svg";